import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "../../components/Button";
import { Form, FileInput, Validation } from "../../components/Form";
import { StyledPaper } from "../../components/Base";
import { fireEvent } from "../../hooks/usePubsub";
import { uploadBankFile } from "../../api/orders";

const validation = {
  bankFile: Validation.required,
};

const MAX_FILE_SIZE = 1024 * 1024 * 10; // 10 Mb

const UploadBankFile = ({ match, history }) => {
  const { t } = useTranslation();

  const submit = async (values) => {
    if (values.bankFile[0]?.size >= MAX_FILE_SIZE) {
      return {
        bankFile: t("file_too_large_10mb"),
      };
    }
    const result = await uploadBankFile({
      files: values.bankFile,
    });

    if (result.status === "ok") {
      history.goBack();
      fireEvent("pending-changed");
      return null;
    } else {
      console.log("error");
      return result?.reason;
    }
    /* 
    if (error) {
      return {
        bankFile: `Error uploading file: ${error}`,
      };
    }
    */
  };

  return (
    <StyledPaper variant="outlined">
      <Form onSubmit={submit} validation={validation}>
        <Box
          sx={{
            m: 2,
          }}
        >
          <Typography variant="subtitle1">{t("upload_bank_file.title")}</Typography>
        </Box>
        <Box
          sx={{
            m: 2,
          }}
        >
          <FileInput name="bankFile" accept="*,.xml" label={t("upload_bank_file.bank_file")} />
        </Box>
        <Box
          sx={{
            m: 2,
          }}
        >
          <Button type="submit" title={t("upload")}>
            {t("upload")}
          </Button>
          <Button title={t("back")} onClick={() => history.goBack()}>
            {t("cancel")}
          </Button>
        </Box>
      </Form>
    </StyledPaper>
  );
};
export default UploadBankFile;
